import React, { useMemo } from 'react';
import './invoice-seen-status.scss';
import { MessageStatus } from '../../constants/enum';
import { SVGS } from '../../assets';

export const InvoiceSeenStatus: React.FC<{
  messageStatus: MessageStatus | null;
}> = ({ messageStatus }) => {
  const statusDetails = useMemo(() => {
    switch (messageStatus) {
      case MessageStatus.MESSAGE_DELIVERED:
        return {
          img: SVGS.Delivered,
          text: 'Delivered',
          classSuffix: 'delivered',
        };
      case MessageStatus.MESSAGE_SEEN:
        return {
          img: SVGS.Seen,
          text: 'Seen',
          classSuffix: 'seen',
        };
      case MessageStatus.MESSAGE_SENT:
        return {
          img: SVGS.Sent,
          text: 'Sent',
          classSuffix: 'sent',
        };
      case MessageStatus.ENGAGED:
        return {
          img: SVGS.Engaged,
          text: 'Engaged',
          classSuffix: 'engaged',
        };
      default:
        return {
          text: '-',
          classSuffix: 'default',
        };
    }
  }, [messageStatus]);

  if (!statusDetails) return null;

  return (
    <div className="invoice-seen-status">
      {statusDetails?.img && (
        <img
          src={statusDetails.img}
          alt={statusDetails.text}
          width={'16px'}
          height={'16px'}
        />
      )}
      <span
        className={`invoice-seen-status-text-${statusDetails.classSuffix} font-semibold`}
      >
        {statusDetails.text}
      </span>
    </div>
  );
};
